module.exports = __webpack_public_path__ + "img/ic24BirthdayBlack.27e7110c.svg";